import Model from './Model';

export default class CarOwner extends Model {
  resource() {
    return 'car-owners';
  }
}
